import {CameraController} from "../cameraController.js";

/**
 * A cinematic camera controller
 */
export class CameraControllerCinematic extends CameraController {
    /**
     * Construct a cinematic camera controller
     * @param {Camera} camera The camera to control
     * @param {CameraAnchor[]} anchors The camera anchors for every track piece index
     * @param {boolean} [targetPlayer] True if this camera should target the player
     */
    constructor(camera, anchors, targetPlayer = true) {
        super(camera, targetPlayer);

        this.anchors = anchors;
        this.anchorCount = anchors.length;
    }

    /**
     * Set the target for this camera controller
     * @param {CameraTargetable} target The target to track
     * @param {Track} track The track
     * @param {number} time The time interpolation in the range [0, 1]
     */
    setTarget(target, track, time) {
        this.camera.position.copy(
            this.anchors[Math.min(target.getTrackPieceIndex(), this.anchorCount - 1)].getPosition(
                target.getPosition(time), target.getDistance(time), track.length));

        super.setTarget(target, track, time);
    }
}